import {
  FRIENDLY_TYPES,
  TYPE_APPOINTMENT,
  TYPE_AREA_BOOKING,
  TYPE_COURSE,
  TYPE_GOLF,
  TYPE_HOTEL_ROOM_RESERVATION,
  TYPE_PACKAGE,
  TYPE_PRODUCT,
  TYPE_SESSION,
  TYPE_TABLE_RESERVATION,
  TYPE_VOUCHER,
} from 'constants/offeringTypes'
import { FC } from 'react'

interface Props {
  colour?: string
  colourFromOffering?: boolean
  cols?: number
  offerings: Array<Record<string, any>>
  onSelect(offering: Record<string, any>): void
  showType?: boolean
}

export const OfferingButtonGrid: FC<Props> = ({
  offerings,
  onSelect,
  cols,
  colour,
  colourFromOffering = false,
  showType = false,
}) => {
  let colsClasses

  switch (cols) {
    default:
    case 7:
      colsClasses = 'grid-cols-4 lg:grid-cols-6 xl:grid-cols-7'
      break
    case 6:
      colsClasses = 'grid-cols-4 lg:grid-cols-5 xl:grid-cols-6'
      break
    case 5:
      colsClasses = 'grid-cols-3 lg:grid-cols-4 xl:grid-cols-5'
      break
    case 4:
      colsClasses = 'grid-cols-3 lg:grid-cols-3 xl:grid-cols-4'
      break
    case 3:
      colsClasses = 'grid-cols-3'
      break
  }

  const offeringColour = (offering) => {
    switch (offering.offering_type) {
      case TYPE_APPOINTMENT:
        return 'yellow'
      case TYPE_SESSION:
        return 'blue'
      case TYPE_AREA_BOOKING:
        return 'green'
      case TYPE_PRODUCT:
        return 'orange'
      case TYPE_COURSE:
        return 'lime'
      case TYPE_PACKAGE:
        return 'purple'
      case TYPE_TABLE_RESERVATION:
        return 'teal'
      case TYPE_GOLF:
        return 'pink'
      case TYPE_VOUCHER:
        return 'red'
      case TYPE_HOTEL_ROOM_RESERVATION:
      default:
        return 'gray'
    }
  }

  return (
    <div className={`grid gap-2 mt-1 ${colsClasses}`}>
      {offerings.map((offering) => (
        <AddOfferingButton
          key={offering.id ?? offering.offering_type}
          offering={offering}
          onSelect={onSelect}
          colour={colourFromOffering ? offeringColour(offering) : colour}
          showType={showType}
        />
      ))}
    </div>
  )
}

const AddOfferingButton = ({ offering, onSelect, colour, showType = false }) => {
  const colourClasses = () => {
    switch (colour) {
      case 'yellow':
        return 'bg-yellow-50 hover:bg-yellow-100 text-yellow-800'
      case 'blue':
        return 'bg-blue-50 hover:bg-blue-100 text-blue-800'
      case 'green':
        return 'bg-green-50 hover:bg-green-100 text-green-800'
      case 'orange':
        return 'bg-orange-50 hover:bg-orange-100 text-orange-800'
      case 'course':
        return 'bg-lime-50 hover:bg-lime-100 text-violet-800'
      case 'purple':
        return 'bg-purple-50 hover:bg-purple-100 text-purple-800'
      case 'teal':
        return 'bg-teal-50 hover:bg-teal-100 text-teal-800'
      case 'pink':
        return 'bg-pink-50 hover:bg-pink-100 text-pink-800'
      case 'red':
        return 'bg-red-50 hover:bg-red-100 text-red-800'
      case 'gray':
      default:
        return 'bg-gray-50 hover:bg-gray-100 text-gray-700'
    }
  }

  return (
    <button
      type="button"
      className={`flex flex-col gap-1 justify-center items-center border border-gray-300 shadow-sm text-gray-700 text-sm px-3 py-2 min-h-16 rounded-md disabled:opacity-50 ${colourClasses()}`}
      onClick={() => onSelect(offering)}
      key={offering.id}
    >
      <div className="font-medium">{offering.name}</div>
      {showType && <div className="font-light">{FRIENDLY_TYPES[offering.offering_type]}</div>}
    </button>
  )
}
